module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_Bg04-sm.ac6ff958.jpg";